var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsTallFescue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4767 45H16.8625C16.8625 45 17.8417 38.0155 12.9712 29.0355C7.343 18.6585 0 15.5654 0 15.5654C0 15.5654 5.51428 23.1329 7.68293 28.4368C10.2805 34.7897 10.4767 45 10.4767 45Z",
    fill: "#008000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7428 45H19.2572C19.2572 45 18.7099 29.6116 16.8625 20.8537C14.1685 8.08204 5.38803 0 5.38803 0C5.38803 0 16.1641 5.28825 20.5543 17.561C25.9797 32.7273 25.7428 45 25.7428 45Z",
    fill: "#008000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7406 24.745C27.2655 26.6613 27.7384 29.7339 27.7384 29.7339C27.7384 29.7339 28.8462 23.2279 30.2328 19.2572C32.4279 12.9712 38.3149 7.48337 38.3149 7.48337C38.3149 7.48337 34.0244 8.88027 31.5299 11.8736C28.4915 15.5197 25.7428 21.6519 25.7428 21.6519C25.7428 21.6519 26.4053 23.5209 26.7406 24.745Z",
    fill: "#008000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3193 45H29.7339C29.7339 45 30.0651 35.7493 32.3282 30.4324C37.0848 19.2572 44.9002 15.5654 44.9002 15.5654C44.9002 15.5654 40.0196 23.4337 38.3149 29.0355C36.4857 35.0464 36.3193 45 36.3193 45Z",
    fill: "#008000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsTallFescue);
export default __webpack_public_path__ + "static/media/ic-crops-Tall-fescue.cb1bbb42f217d1d5e4894f61738db473.svg";
export { ForwardRef as ReactComponent };